<template>
  <v-chip :class="chipClass" small>
    {{ chipText }}
  </v-chip>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'StatusChip',
  props: {
    status: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    chipClass(): string {
      return this.status ? 'green lighten-5 green--text' : 'grey white--text';
    },
    chipText(): string {
      return this.status ? 'Habilitado' : 'Deshabilitado';
    }
  }
});
</script>
